module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-04.65136d12.svg";